import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import ElectricBoltIcon from "@mui/icons-material/ElectricBoltOutlined";
import BalanceIcon from "@mui/icons-material/BalanceOutlined";
import HowToRegIcon from "@mui/icons-material/HowToRegOutlined";
import HandshakeIcon from "@mui/icons-material/HandshakeOutlined";

export const benefits = [
  {
    icon: WorkspacePremiumIcon,
    title: "Practitioner-led approach",
    desc: "Led by hands-on experts who actively implement solutions, not just advise.",
  },
  {
    icon: ElectricBoltIcon,
    title: "Real-time execution",
    desc: "Strategies are executed alongside planning to deliver immediate, measurable results.",
  },
  {
    icon: BalanceIcon,
    title: "Vendor-neutral mindset",
    desc: "We recommend the best solutions for your needs—independent of any platform.",
  },
  {
    icon: HowToRegIcon,
    title: "Focus on adoption & usability",
    desc: "We design user-friendly systems that drive adoption and improve efficiency.",
  },

  {
    icon: HandshakeIcon,
    title: "Long-term partnership",
    desc: "We stay with you beyond delivery, ensuring continuous improvement and growth.",
  },
];

export const comparison = [
  {
    left: "Hands-on execution",
    right: "Strategy only",
  },
  {
    left: "Real-time collaboration",
    right: "Limited interaction",
  },
  {
    left: "Continuous improvement",
    right: "One-time delivery",
  },
  {
    left: "Business-focused",
    right: "Tool-focused",
  },
];
